export const AppCard = ({
  name,
  description,
  cardMenu,
  cardButtons,
  icon,
}: {
  name: string
  description: string
  cardMenu: React.ReactNode
  cardButtons: React.ReactNode
  icon: React.ReactNode
}) => {
  const leftIcon = (
    <div className="flex h-12 w-12 flex-shrink-0 flex-grow-0 items-center justify-center self-start rounded-full bg-grey-lightest p-2 text-grey-dark">
      {icon}
    </div>
  )

  const titleDescription = (
    <div className="flex flex-col justify-between gap-1">
      <div className="text-base">{name}</div>
      <div className="text-xs font-light">{description}</div>
    </div>
  )

  return (
    <div className="grid grid-cols-[1fr_4fr_1fr] gap-2 rounded-lg bg-white p-4 shadow">
      {leftIcon}
      {titleDescription}
      {cardMenu}
      <div className="col-span-2 col-start-2 flex flex-row justify-end gap-2 border-t pt-3">{cardButtons}</div>
    </div>
  )
}
